import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';

import * as datetime from 'legacy/common/utils/datetime';

type Props = {
  startDate: string;
  endDate: string;
  activeStatus: string;
};

const EventDate: React.FC<Props> = ({ startDate, endDate, activeStatus }) => {
  const formattedStartDate = datetime.format(startDate, 'dddd, MMM Do, YYYY');
  const formattedStartTime = datetime.format(startDate, 'hh:mm A');
  const isStartEndSameDate = endDate
    ? datetime.isSame(startDate, endDate, 'day')
    : true;
  const formattedEndDate =
    endDate && datetime.format(endDate, 'dddd, MMM Do, YYYY');
  const formattedEndTime = endDate && datetime.format(endDate, 'hh:mm A');

  if (activeStatus === 'past') {
    return (
      <>
        <FaCheckCircle />
        Event has passed!
      </>
    );
  }

  if (isStartEndSameDate) {
    return (
      <>
        {`${formattedStartDate} • ${formattedStartTime}`}
        {formattedEndTime && ` - ${formattedEndTime}`}
      </>
    );
  }

  return (
    <div className="flex flex-col gap-1">
      <p>
        Starts: {formattedStartDate} • {formattedStartTime}
      </p>
      <p>
        Ends: {formattedEndDate} • {formattedEndTime}
      </p>
    </div>
  );
};

export default EventDate;
